import React, {useEffect, useRef, useState} from "react";
import Confirm from "../component/molecules/Confirm";
import {requestAddNewHistory, createNewCustomerId} from "../api/designHistoryApi";
import Alert from "../component/molecules/Alert";
import {useSelector} from "react-redux";
import CustomerCodeInput from "../component/organisms/CustomerCodeInput";
import useHistory from "./useHistory";
import CopyButton from "../component/atom/CopyButton";
import useTakeScreenShot from "../../../hooks/core/useTakeScreenShot";

const useAddHistory = () => {
  const currentVehicle = useSelector(state => state.optionWindow.currentVehicle);
  const bespokeCode = useSelector(state => state.qrcode.configId);
  const configData = useSelector(state => state.optionWindow.configData);

  const background = configData?.BACKGROUND;

  const {screenShot, screenShotReady, summaryImageElement} = useTakeScreenShot();
  const {getConfigurationList} = useHistory();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  }

  const containerRef = useRef();


  const closeModalConfirm = (subModalMount, closeModal, closeSubModal) => {
    subModalMount(
      <Confirm closeSubModal={closeSubModal}
               closeModal={closeModal}
               title={"WARNING"}
               message={"Unsaved changes will be lost. Are you sure you want to close this window?"}
      />, true);
  }




  const customMessage = (customerId) => (
    <div className="custom-message-container">
      <p className="custom-message-text">
        Your design has been saved to Customer Code. Please make sure to remember the code below.
      </p>


      <div className="custom-message-code-container">
        <strong className="customer-message-customer-code">
          {customerId}
        </strong>
        <CopyButton textToCopy={customerId} />
      </div>
    </div>
  );


  const formatDateTime = (dateTimeStr) => {
    return dateTimeStr.replace('T', ' ').substring(0, 19);
  };

  const addNewHistory = (customerId, addDesignPayload, closeSubModal, subModalMount, closeModal) => {
    requestAddNewHistory(customerId, bespokeCode, addDesignPayload).then(res => {
      const { result, message } = res.data;
      if (result && message === "SUCCESS") {
        closeSubModal();


        subModalMount(
          <Alert title={message}
                 message={customMessage(customerId)}
                 closeModal={closeModal}
                 closeSubModal={closeSubModal}
                 callback={() => {
                   const userType = sessionStorage.getItem("userRole");
                   if (userType === "CONFIGURATION_USER") {
                     getConfigurationList(customerId);
                   }
                 }}
          />
          , true
        );
      }
    }).catch(error => {
      if (error.response?.status === 409) {
        closeSubModal();
        const responseMessage = error.response?.data?.message;
        const createdAtRegex = /createdAt: ([^,]+)/;
        const titleRegex = /title: ([^)]+)/;

        const createdAtMatch = responseMessage.match(createdAtRegex);
        const titleMatch = responseMessage.match(titleRegex);

        const createdAt = createdAtMatch ? formatDateTime(createdAtMatch[1]) : null;
        const title = titleMatch ? titleMatch[1] : null;


        subModalMount(
          <Alert
            title={"ALERT"}
            message={`Duplicate design exists in your design archive.\n Title : ${title} (${createdAt})`}
            closeSubModal={closeSubModal}
          />
        )

      }
    });
  }



  const handleAddNewHistory = (noCustomerCode, customerId, subModalMount, closeModal, closeSubModal) => {

    const payloadAddNewHistory = {
      configData: JSON.stringify(configData),
      productId: currentVehicle.id,
      customerId: Number(customerId),
      title: formData.title,
      description: formData.description,
      extImage: screenShot[0]?.img,
      intImage: screenShot[2]?.img,
      hash: bespokeCode,
      background: background,
      configurationType: "USER",
      bespokeCode: bespokeCode,
    }

    if (noCustomerCode) {
      const payloadCreateCustomerId = {
        description: ""
      }

      const handleCustomerCreation = async () => {
        try {
          const res = await createNewCustomerId(payloadCreateCustomerId);
          const {result, message, data} = res.data;

          if (result && message === "SUCCESS") {
            const customerId = data.id;
            payloadAddNewHistory.customerId = customerId;

            addNewHistory(customerId, payloadAddNewHistory, closeSubModal, subModalMount, closeModal);
          }


        } catch (e) {
          console.log(e);
        }

      }

      handleCustomerCreation();



    } else {
      addNewHistory(customerId, payloadAddNewHistory, closeSubModal, subModalMount, closeModal);
    }


  }



  const showCustomerCodeInput = (subModalMount, closeModal, closeSubModal) => {
    subModalMount(
      <CustomerCodeInput closeModal={closeModal}
                         closeSubModal={closeSubModal}
                         subModalMount={subModalMount}
                         handleAddNewHistory={handleAddNewHistory}
      />, true);
  }







  useEffect(() => {
    containerRef.current &&
    containerRef.current.addEventListener("wheel", (e) => {
      e.stopPropagation();
    }, { passive: false })
  }, []);

  return {
    formData, handleInputChange, containerRef, closeModalConfirm, showCustomerCodeInput, screenShot, screenShotReady, summaryImageElement
  }
}

export default useAddHistory;
